import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import { persistor } from './redux/store'
import { PersistGate } from 'redux-persist/integration/react'
import { App } from './app/app'
import reportWebVitals from './report-web-vitals'
import { initTranslation } from './translation/i18n'
import {
    FRESHCHAT_ACCOUNT_ID,
    FRESHCHAT_APP_ID,
    FRESHCHAT_CDN_HOST,
    FRESHCHAT_LOADER_ID,
} from './constants/freshchat'

const container = document.getElementById('root')
// @ts-ignore
const root = createRoot(container)
initTranslation()
root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <App />
        </PersistGate>
    </Provider>,
)

function initializeFreshchatWidget() {
    if (document.getElementById(FRESHCHAT_LOADER_ID)) return

    window.fcWidgetMessengerConfig = {
        faqTags: {
            tags: ['koti'],
            filterType: 'category',
        },
        siteId: process.env.REACT_APP_FRESHCHAT_SITE_ID ?? 'KOTI',
        config: {
            headerProperty: {
                appName: 'Koti',
                appLogo: 'https://koti.no/static/media/koti.1ba947efd70035c8c292faaad4ac8f14.svg',
                backgroundImage: '#ffffff',
                backgroundColor: '#273a57',
                foregroundColor: '#ffffff',
            },
        },
    }

    const script = document.createElement('script')
    script.id = FRESHCHAT_LOADER_ID
    script.async = true
    script.src = `${FRESHCHAT_CDN_HOST}/${FRESHCHAT_ACCOUNT_ID}/${FRESHCHAT_APP_ID}.js`
    script.setAttribute('chat', 'true')
    if (process.env.REACT_APP_FRESHCHAT_TOKEN) {
        script.setAttribute('widgetId', process.env.REACT_APP_FRESHCHAT_TOKEN)
    }
    document.head.appendChild(script)
}

window.addEventListener('load', initializeFreshchatWidget)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
